<div class="review-carousel-container">
  <app-block-wrapper [style]="style" [_editable]="_editable">
    <div class="carousel-container">
      <div class="review-carousel" #carouselEl (scroll)="onScroll()">
        <div class="reviews">
          @for (review of reviewData; track review) {
            <div class="review">
              <div class="stars">
                @for (star of review.stars; track star) {
                  <div [class]="star"></div>
                }
              </div>

              <div
                class="text"
                [innerHTML]="'<span>“</span>' + (review.text | storyblokRichText | stripOuterPTag) + '<span>”</span>'"
              ></div>

              <div class="reviewer">
                @if (review.reviewerAvatar?.filename) {
                  <img [src]="review.reviewerAvatar.filename" width="40" height="40" alt="" />
                }
                <div class="name">{{ review.reviewerName }}</div>
                @if (review.link) {
                  <a [href]="review.link" class="role standard-text" target="_blank" rel="nofollow noreferrer noopener">
                    {{ review.reviewerRole }}
                    @if (review.reviewerCompany) {
                      at {{ review.reviewerCompany }}
                    }
                  </a>
                } @else {
                  <div class="role standard-text">
                    {{ review.reviewerRole }}
                    @if (review.reviewerCompany) {
                      at {{ review.reviewerCompany }}
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (reviewData.length > 1) {
      <div class="dots">
        @for (review of reviewData; track review; let i = $index) {
          <div class="dot" [class.active]="i === index" (click)="goTo(i, true)"></div>
        }
      </div>
    }
  </app-block-wrapper>
  @if (reviewData.length > 1) {
    <div class="arrow left" (click)="previous(true)">
      <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
    </div>
    <div class="arrow right" (click)="next(true)">
      <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
    </div>
  }
</div>
